const theme = {
  breakpoints: ["420px", "1000px", "1440px", "2000px"],
  fontSizes: [14, 16, 18, 20, 22, 25, 26, 28, 32, 36, 46, 62],
  space: [
    0, //! recommended VS Code Plugin: https://marketplace.visualstudio.com/items?itemName=aaron-bond.better-comments
    "0.125rem", //* 1 – 2px
    "0.25rem", //* 2 – 4px
    "0.5rem", //* 3 – 8px
    "0.75rem", //* 4 – 12px
    "1rem", //* 5 – 16px
    "1.25rem", //* 6 – 20px
    "1.5rem", //* 7 – 24px
    "2rem", //* 8 – 32px
    "2.5rem", //* 9 – 40px
    "3rem", //* 10 – 48px
    "3.5rem", //* 11 – 56px
    "4rem", //* 12 – 64px
    "4.5rem", //* 13 – 72px
    "5rem", //* 14 – 80px
    "5.5rem", //* 15 – 88px
    "6rem", //* 16 – 96px
    "7rem", //* 17 – 112px
    "8rem", //* 18 – 128px
  ],

  fonts: {
    body: "GTWalsheimPro, system-ui, sans-serif",
    heading: "SofiaPro, system-ui, sans-serif",
    caption: "SofiaPro, system-ui, sans-serif",
  },
  shadows: {
    control: "0px 0px 5px rgba(0,0,0,0.15)",
  },
  fontWeights: {
    ultraLight: 100,
    thin: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900,
    body: 400,
    heading: 400,
  },

  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },

  sizes: {
    container: "2000px",
    content: "800px",
  },

  colors: {
    transparent: "#00000000",
    background: "#fff",
    darkblue: "#232942",
    darkerblue: "#232A41",
    "bg-dark": "#040b1a",
    "border-light": "#3d653944",
    primary: "#212941",
    green_300: "#3E643B",
    green_400: "#185341",
    blue_100: "#DAE3EA",
    blue_200: "#88B8CC",
    blue_300: "#1D6C97",
    gray_100: "#f6f8fa",
    gray_200: "#f9f9fa",
    purple_300: "#8172C3",
    accent: "#ff0000",
    gold_100: "#EBC600",
    stage: "#DADD3E",
    icon_link: "#AEC2D3",
    gold: "#FFD900",
    green_600: "#317752",
    almostBlack: "#111111",
    black: "#000000",
  },

  styles: {
    root: {
      fontFamily: "body",
      lineHeight: "body",
      fontWeight: "body",
      color: "almostBlack",
      fontSize: 2,
    },
  },

  container: {
    root: {
      fontFamily: "body",
      lineHeight: "body",
      fontWeight: "body",
      color: "almostBlack",
      fontSize: 2,
    },
  },

  text: {
    h1: {
      fontSize: [9, 9, 11],
      fontFamily: "heading",
      fontWeight: "regular",
      lineHeight: ["38px", "38px", "62px"],
      letterSpacing: ["-2.2px", "-2.2px", "-3.6px"],
    },
    h2: {
      fontSize: ["28px", "28px", "38px"],
      fontFamily: "heading",
      fontWeight: ["medium", "medium", "regular"],
      lineHeight: ["30px", "30px", "44px"],
      letterSpacing: "-1.24px",
    },

    h3: {
      fontSize: [4, 4, 7],
      fontFamily: "heading",
      fontWeight: ["regular", "regular", "medium"],
      lineHeight: ["26px", "26px", "32px"],
      letterSpacing: ["0px", "0px", "-1px"],
    },

    h4: {
      fontSize: [3, 3, 6],
      fontFamily: "heading",
      fontWeight: "light",
      lineHeight: ["26px", "26px", "32px"],
      letterSpacing: "0px",
    },

    h5: {
      fontSize: 3,
      fontFamily: "heading",
      fontWeight: "light",
      lineHeight: "26px",
      letterSpacing: "0px",
    },
    h6: {
      fontSize: 0,
      fontFamily: "heading",
      fontWeight: "regular",
      textTransform: "uppercase",
      lineHeight: "16px",
      letterSpacing: "1px",
    },
    subtitle1: {
      fontSize: [4, 4, 5],
      fontFamily: "body",
      fontWeight: "thin",
      lineHeight: ["28px", "28px", "25px"],
      letterSpacing: ["0.16px", "0.16px", "0.64px"],
    },
    subtitle2: {
      fontSize: [3, 3, 4],
      fontFamily: "body",
      fontWeight: ["thin", "thin", "light"],
      lineHeight: ["26px", "26px", "32px"],
      letterSpacing: ["0.16px", "0.16px", "0.24px"],
    },
    subline: {
      fontFamily: "body",
      fontSize: "22px",
      fontWeight: "light",
      letterSpacing: "0.24px",
      lineHeight: "28px",
    },
    body1: {
      fontSize: 2,
      fontFamily: "body",
      fontWeight: "light",
      lineHeight: "26px",
      letterSpacing: "0.24px",
    },
    body2: {
      fontSize: 1,
      fontFamily: "body",
      fontWeight: ["regular", "regular", "light"],
      lineHeight: "24px",
      letterSpacing: "0.24px",
    },
    small1: {
      fontSize: 0,
      fontFamily: "body",
      fontWeight: ["light", "light", "regular"],
      lineHeight: "18px",
      letterSpacing: "0px",
    },
    button: {
      fontSize: 0,
      fontFamily: "body",
      fontWeight: "regular",
      textTransform: "uppercase",
      lineHeight: "14px",
      letterSpacing: "1.48px",
    },
  },

  button: {
    contained: {},
    outlined: {
      display: "inline-block",
      lineHeight: 1,
      color: "almostBlack",
      borderWidth: ["2px", "3px"],
      borderStyle: "solid",
      borderColor: "almostBlack",
      py: 4,
      px: 7,
      textAlign: "center",
      textDecoration: "none",
      textTransform: "uppercase",
      fontFamily: "heading",
      fontSize: [2, 3, 4],
    },
  },

  link: {
    body1: {
      color: "blue_300",
      textDecoration: "none",
      fontSize: 2,
      fontFamily: "body",
      fontWeight: "light",
      lineHeight: "26px",
      letterSpacing: "0.24px",
      transition: "all 0.2s linear",
      ":hover": {
        color: "blue_200",
      },
    },
  },
}

export { theme }
